"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dbo = require("../base-objects/models");
var DeliverableTopReadOnly = /** @class */ (function (_super) {
    __extends(DeliverableTopReadOnly, _super);
    function DeliverableTopReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableTopReadOnly;
}(dbo.DeliverableCommonReadOnly));
exports.DeliverableTopReadOnly = DeliverableTopReadOnly;
var DeliverableProductHeadReadOnly = /** @class */ (function (_super) {
    __extends(DeliverableProductHeadReadOnly, _super);
    function DeliverableProductHeadReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableProductHeadReadOnly;
}(dbo.DeliverableProductBase));
exports.DeliverableProductHeadReadOnly = DeliverableProductHeadReadOnly;
var DeliverableProductChildReadOnly = /** @class */ (function (_super) {
    __extends(DeliverableProductChildReadOnly, _super);
    function DeliverableProductChildReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableProductChildReadOnly;
}(dbo.DeliverableProductChildBase));
exports.DeliverableProductChildReadOnly = DeliverableProductChildReadOnly;
var DeliverableWorkTypeHeadReadOnly = /** @class */ (function (_super) {
    __extends(DeliverableWorkTypeHeadReadOnly, _super);
    function DeliverableWorkTypeHeadReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableWorkTypeHeadReadOnly;
}(dbo.DeliverableWorkTypeBase));
exports.DeliverableWorkTypeHeadReadOnly = DeliverableWorkTypeHeadReadOnly;
var DeliverableWorkTypeChildReadOnly = /** @class */ (function (_super) {
    __extends(DeliverableWorkTypeChildReadOnly, _super);
    function DeliverableWorkTypeChildReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableWorkTypeChildReadOnly;
}(dbo.DeliverableWorkTypeChildBase));
exports.DeliverableWorkTypeChildReadOnly = DeliverableWorkTypeChildReadOnly;
var PlaceholderProductHeadReadOnly = /** @class */ (function (_super) {
    __extends(PlaceholderProductHeadReadOnly, _super);
    function PlaceholderProductHeadReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlaceholderProductHeadReadOnly;
}(dbo.DeliverableProductBase));
exports.PlaceholderProductHeadReadOnly = PlaceholderProductHeadReadOnly;
var PlaceholderProductChildReadOnly = /** @class */ (function (_super) {
    __extends(PlaceholderProductChildReadOnly, _super);
    function PlaceholderProductChildReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlaceholderProductChildReadOnly;
}(dbo.DeliverableProductChildBase));
exports.PlaceholderProductChildReadOnly = PlaceholderProductChildReadOnly;
var PlaceholderUnAssignedWorkReadOnly = /** @class */ (function (_super) {
    __extends(PlaceholderUnAssignedWorkReadOnly, _super);
    function PlaceholderUnAssignedWorkReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlaceholderUnAssignedWorkReadOnly;
}(dbo.DeliverableChildBase));
exports.PlaceholderUnAssignedWorkReadOnly = PlaceholderUnAssignedWorkReadOnly;
var PlaceholderWorkTypeHeadReadOnly = /** @class */ (function (_super) {
    __extends(PlaceholderWorkTypeHeadReadOnly, _super);
    function PlaceholderWorkTypeHeadReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlaceholderWorkTypeHeadReadOnly;
}(dbo.DeliverableWorkTypeBase));
exports.PlaceholderWorkTypeHeadReadOnly = PlaceholderWorkTypeHeadReadOnly;
var PlaceholderWorkTypeChildReadOnly = /** @class */ (function (_super) {
    __extends(PlaceholderWorkTypeChildReadOnly, _super);
    function PlaceholderWorkTypeChildReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlaceholderWorkTypeChildReadOnly;
}(dbo.DeliverableWorkTypeChildBase));
exports.PlaceholderWorkTypeChildReadOnly = PlaceholderWorkTypeChildReadOnly;
// only in client
var DeliverableFeatureChildren = /** @class */ (function (_super) {
    __extends(DeliverableFeatureChildren, _super);
    function DeliverableFeatureChildren() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableFeatureChildren;
}(dbo.DeliverableBase));
exports.DeliverableFeatureChildren = DeliverableFeatureChildren;
// only in client
var DeliverableFeatureProduct = /** @class */ (function (_super) {
    __extends(DeliverableFeatureProduct, _super);
    function DeliverableFeatureProduct() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableFeatureProduct;
}(DeliverableFeatureChildren));
exports.DeliverableFeatureProduct = DeliverableFeatureProduct;
